import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  // 路由变化时关闭菜单
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  useEffect(() => {
    if (!user) return;
    const fetchUnread = () => {
      api.get('/messages/unread-count')
        .then(res => setUnreadCount(res.data.count || 0))
        .catch(() => {});
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);
    return () => clearInterval(interval);
  }, [user]);

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/');
  };

  return (
    <>
      <nav className="navbar">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <div className="logo-icon">RS</div>
            <span className="brand-text">
              <span className="brand-en">RollSleeves</span>
              <span className="brand-cn">卷袖</span>
            </span>
          </Link>

          <div className="navbar-links">
            <Link to="/">首页</Link>
            <Link to="/jobs">岗位列表</Link>
            <Link to="/candidates">人才广场</Link>
            <Link to="/experts">职业咨询</Link>
            {user && <Link to="/post-job">发布岗位</Link>}
            {user && <Link to="/my-jobs">我的岗位</Link>}
            {user && <Link to="/my-favorites">我的收藏</Link>}
            <Link to="/feedback">联系我们</Link>
            {user && user.role === 'admin' && <Link to="/admin">管理后台</Link>}
          </div>

          <div className="navbar-actions">
            {user ? (
              <>
                <Link to="/messages" className="btn btn-ghost btn-sm" style={{ position: 'relative' }}>
                  消息
                  {unreadCount > 0 && (
                    <span style={{
                      position: 'absolute', top: 2, right: 2,
                      background: 'var(--error)', color: 'white', borderRadius: '50%',
                      width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: '0.65rem', fontWeight: 700,
                    }}>{unreadCount > 9 ? '9+' : unreadCount}</span>
                  )}
                </Link>
                <Link to="/my-profile" className="btn btn-ghost btn-sm">
                  {user.nickname || user.displayName || user.username}
                </Link>
                <button onClick={handleLogout} className="btn btn-secondary btn-sm">
                  退出
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-ghost btn-sm">登录</Link>
                <Link to="/register" className="btn btn-primary btn-sm">注册</Link>
              </>
            )}

            {/* 汉堡按钮（仅移动端可见） */}
            <button
              className="hamburger-btn"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="菜单"
            >
              <span className={`hamburger-icon ${menuOpen ? 'open' : ''}`}>
                <span /><span /><span />
              </span>
            </button>
          </div>
        </div>
      </nav>

      {/* 移动端侧边抽屉 */}
      {menuOpen && <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)} />}
      <div className={`mobile-menu ${menuOpen ? 'mobile-menu-open' : ''}`}>
        <div className="mobile-menu-links">
          <Link to="/">首页</Link>
          <Link to="/jobs">岗位列表</Link>
          <Link to="/candidates">人才广场</Link>
          <Link to="/experts">职业咨询</Link>
          {user && <Link to="/post-job">发布岗位</Link>}
          {user && <Link to="/my-jobs">我的岗位</Link>}
          {user && <Link to="/my-favorites">我的收藏</Link>}
          {user && <Link to="/messages">
            消息{unreadCount > 0 && <span className="mobile-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>}
          </Link>}
          <Link to="/feedback">联系我们</Link>
          {user && user.role === 'admin' && <Link to="/admin">管理后台</Link>}
        </div>
        <div className="mobile-menu-bottom">
          {user ? (
            <>
              <Link to="/my-profile" className="mobile-menu-user">
                {user.nickname || user.displayName || user.username}
              </Link>
              <button onClick={handleLogout} className="btn btn-secondary" style={{ width: '100%' }}>退出登录</button>
            </>
          ) : (
            <div style={{ display: 'flex', gap: 8 }}>
              <Link to="/login" className="btn btn-ghost" style={{ flex: 1, textAlign: 'center' }}>登录</Link>
              <Link to="/register" className="btn btn-primary" style={{ flex: 1, textAlign: 'center' }}>注册</Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Navbar;
